
import logoSrc from '~/assets/img/logo.svg';

export default {
  name: 'main-logo',
  props: {
    hideText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      logoSrc,
    };
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
  },
};
